// extracted by mini-css-extract-plugin
export default {"container":"styles-module--container--2t_fo","label":"styles-module--label--2du1H"};